/**
 * Colors used to distinguish branch lanes ("spaces") in the network graph. Kept in a standalone,
 * dependency-free module so both the canvas chart and the React table view (including its
 * server-rendered partial bundle) can share a single source of truth without pulling in the
 * browser-only canvas code. These are intentionally raw hex values (not Primer tokens): they are
 * the fixed chart lane colors the canvas draws with, and the table dot must match them exactly.
 */
export const SPACE_COLORS = [
  '#c0392b',
  '#3498db',
  '#2ecc71',
  '#8e44ad',
  '#f1c40f',
  '#e67e22',
  '#34495e',
  '#e74c3c',
  '#2980b9',
  '#1abc9c',
  '#9b59b6',
  '#f39c12',
  '#7f8c8d',
  '#2c3e50',
  '#d35400',
  '#e74c3c',
  '#95a5a6',
  '#bdc3c7',
  '#16a085',
  '#27ae60',
] as const

/** Fallback lane color, used when a computed lane index falls outside the palette. */
export const DEFAULT_SPACE_COLOR = SPACE_COLORS[0]
